/* eslint-disable max-len */
import 'react';

const DepartmentSearchCleanSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16px" height="16px" viewBox="0 0 16 16" version="1.1" {...props}>
        <defs>
            <rect id="path-1" x="0" y="0" width="16" height="16" />
        </defs>
        <g id="组件" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="搜索/输入态" transform="translate(-252.000000, -10.000000)">
                <g id="icon_关闭" transform="translate(252.000000, 10.000000)">
                    <mask id="mask-2" fill="white">
                        <use xlinkHref="#path-1" />
                    </mask>
                    <g id="矩形" />
                    <g id="编组-6" mask="url(#mask-2)" fill="#CCCCCC" fillRule="nonzero">
                        <g transform="translate(7.500000, 8.500000) rotate(-315.000000) translate(-7.500000, -8.500000) translate(1.000000, 2.000000)">
                            <path d="M6.5,-0.75 C6.87969577,-0.75 7.19349096,-0.467846118 7.24315338,-0.101770557 L7.25,0 L7.25,13 C7.25,13.4142136 6.91421356,13.75 6.5,13.75 C6.12030423,13.75 5.80650904,13.4678461 5.75684662,13.1017706 L5.75,13 L5.75,0 C5.75,-0.414213562 6.08578644,-0.75 6.5,-0.75 Z" id="路径-6" />
                            <path d="M13,5.75 C13.4142136,5.75 13.75,6.08578644 13.75,6.5 C13.75,6.87969577 13.4678461,7.19349096 13.1017706,7.24315338 L13,7.25 L0,7.25 C-0.414213562,7.25 -0.75,6.91421356 -0.75,6.5 C-0.75,6.12030423 -0.467846118,5.80650904 -0.101770557,5.75684662 L0,5.75 L13,5.75 Z" id="路径-6备份" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>);
export default DepartmentSearchCleanSvg;
